module.exports = __webpack_public_path__ + "img/20251113.2ca68c05.jpg";